<template>
	<div class="relative pb-4 sm:pb-6 mt-6 mb-6 sm:mt-10 sm:mb-10 bg-dj-blue/5 overflow-hidden max-w-[100%]">
		<AdaptiveContainer class="relative flex justify-between pt-6 sm:pt-10 pr-12 pl-0 sm:pl-12 z-10">
			<div>
				<p class="text-dj-gray text-base sm:text-xl">{{ $t("testimonials.subtitle") }}</p>
				<BaseHeading type="h2" class="my-3 col-span-full relative">
					{{ $t("testimonials.heading") }}
				</BaseHeading>
			</div>
		</AdaptiveContainer>
		<div class="relative z-10">
			<CarouselTestimonials></CarouselTestimonials>
		</div>

		<div class="absolute hidden sm:flex w-full h-full left-0 top-0 bg-white">
			<AdaptiveContainer
				class="absolute bg-dj-blue/5 sm:rounded-3xl top-0 h-full w-full sm:left-[50%] sm:translate-x-[-50%]"
			></AdaptiveContainer>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "Testimonials",
	setup() {
		const { locale } = useI18n({
			useScope: "global",
		});

		return {
			locale,
		};
	},
});
</script>
